import MDTypography from "components/MDTypography";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import OutgoingCallIcon from "../../../assets/images/outgoing-call.png";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
function IncommingOutgoingCallCell({ value, suffix, row }) {
  let icon = null;
  const isMissCall = row?.original?.isMissed;

  if (value === "OUT") {
    icon = (
      <img
        src={OutgoingCallIcon}
        alt="Outgoing Call"
        style={{
          width: "35px",
          height: "35px",
          filter:
            "invert(39%) sepia(65%) saturate(2650%) hue-rotate(185deg) brightness(94%) contrast(92%)",
        }}
      />
    );
  } else if (value === "IN") {
    if (isMissCall) {
      icon = (
        <PhoneMissedIcon
          style={{
            color: "#f44336",
            width: "32px",
            height: "32px",
          }}
        />
      );
    } else {
      icon = (
        <PhoneCallbackIcon
          style={{
            color: "#4CAF50",
            width: "32px",
            height: "32px",
          }}
        />
      );
    }
  }

  return (
    <MDTypography variant="caption" fontWeight="large" color="text">
      {icon || value}
      {suffix && (
        <MDTypography variant="caption" fontWeight="large" color="secondary">
          &nbsp;&nbsp;{suffix}
        </MDTypography>
      )}
    </MDTypography>
  );
}

IncommingOutgoingCallCell.defaultProps = {
  suffix: "",
};

export default IncommingOutgoingCallCell;
